import { render } from "./alarmProfilesEdit.vue?vue&type=template&id=e1ec8166"
import script from "./alarmProfilesEdit.vue?vue&type=script&lang=js"
export * from "./alarmProfilesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__